import { useQuery, useMutation } from "@tanstack/react-query";
import { fetch3, fetch4 } from "../commonApis/commonApis";
import { useDispatch } from "react-redux";
import { setUnifiedManifestList, addUnifiedManifest } from "../features/unifiedManifest/unifiedManifestSlice";

const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
}

export const useFetchUnifiedManifestData = (
  page: number,
  limit: number,
  searchFor: string,
  type?: string
) => {
  const dispatch = useDispatch();

  return useQuery({
    queryKey: ["unifiedManifest", page, limit, searchFor, type],
    queryFn: async () => {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
        searchFor: searchFor || "",
        type: type || "LM",
      });

      const res = await fetch3(
        `${url}/api/unified-manifest?${params.toString()}`,
        "get"
      );

      if (!res || !res.data) return res?.message;

      dispatch(setUnifiedManifestList(res.data));
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useCreateUnifiedManifestMutation = () => {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(
        `${url}/api/unified-manifest/create`,
        payload
      );

      if (!res.success) {
        throw new Error(res.message || "Something went wrong");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      dispatch(addUnifiedManifest(data));
      console.log("✅ Unified Manifest Created:", data);
    },
    onError: (error: any) => {
      console.error("❌ Unified Manifest creation failed:", error.message);
    },
  });
};
